<app-simple-stacked-bar-chart
  [data]="data"
  [leftLabel]="'charts.labels.topics' | translate"
  [rightLabel]="'charts.labels.count' | translate"
></app-simple-stacked-bar-chart>
